module.exports = __webpack_public_path__ + "img/zhouchang_pink.7c2e7e77.png";